(function ($, global) {

  /**
   * Провайдер данных для выбора из справочника.
   * @since 5.5.0.1000
   */
  var DocumentSelectDataProvider = {
    /**
     * Отправляет запрос на сервер и обрабатывает результаты.
     * @param {string} url Адрес веб-сервиса или веб-хэндлера.
     * @param {Object} params Список параметров веб-сервиса или веб-хэндлера.
     * @param {successCallback} OnSuccess Функция, вызываемая при удачном выполнении запроса от сервера.
     * @param {errorCallback} OnError Функция, вызываемая при НЕ удачном выполнении запроса от сервера.
     * @returns {jqXHR} Объект запроса возвращаемой функцией jQuery.ajax.
     */
    sendQuery: function (url, params, OnSuccess, OnError) {
      var me = this;

      return WA.SRV.call('/api/LinkQuery.asmx/GetDocumentsFromQueryContext', {
        queryContext: $.parseJSON(params.queryContext),
        queryString: params.q,
        pageSize: params.limit,
        pageNumber: params.page,
        sortRequisite: 'ISBEDocTextModifyDate',
        sortDirection: -1
      }, null, null, true, true).done(function (data) {
        var entities = $.parseJSON(data).map(function (docLink) {
          var iconName = g_ImgsByDocExt[docLink.ext.toLowerCase()];
          if (!iconName) iconName = 'documentUnknown';
          var editorIcon = '<svg class="svg-component document-requisite__extension-icon"><use xlink:href="#' + iconName + '-16"/></svg> ';
          var signIcon = '';
          switch (docLink.sign) {
            case 'APPR':
              signIcon = '<svg xmlns="http://www.w3.org/2000/svg" class="Version_Table_Sign_Img"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#signRed-16" /></svg>';
            case 'AUTH':
              signIcon = '<svg xmlns="http://www.w3.org/2000/svg" class="Version_Table_Sign_Img"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#signYellow-16" /></svg>';
          }
          var icon = '<span class="version-list__version-icon">' + editorIcon + signIcon + '</span>';
          return {
            id: docLink.id,
            encodedTitle: icon + docLink.name.escapeHtml(),
            title: docLink.name,
            leadingRequisitesValue: "{}"
          };
        });

        if (OnSuccess) OnSuccess(1000000, entities);

      }).fail(function (errorMessage) {
        if (OnError) OnError(errorMessage, false);
      });
    }
  };

  global.DocumentSelectDataProvider = DocumentSelectDataProvider;

})(jQuery, window.Core.requisites);
